var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.45,29a2.08,2.08,0,0,1-.9-.21l-5.79-2.9H10a8,8,0,0,1-8-8v-6a8,8,0,0,1,8-8H22a8,8,0,0,1,8,8v6a8,8,0,0,1-1.64,4.85l1,3.73A2,2,0,0,1,27.45,29ZM10,5.89a6,6,0,0,0-6,6v6a6,6,0,0,0,6,6H21a1,1,0,0,1,.45.11l6,3-1.16-4.24a1,1,0,0,1,.22-.92A6,6,0,0,0,28,17.89v-6a6,6,0,0,0-6-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,19H8a1,1,0,0,1,0-2H24a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,13H8a1,1,0,0,1,0-2H24a1,1,0,0,1,0,2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.92d754ecdbcde8ac4adfce09f7659049.svg";
export { ForwardRef as ReactComponent };